import React from "react";
import BackgroundTexture from "../../Elements/Textures/BackgroundTexture";
import Logo from "../../Components/UI/Logo/Logo";
import FreeSpinReelSet from "./FreeSpinReelSet/FreeSpinReelSet";
import FreeSpinsAnimation from "../../Components/Animations/FreeSpinsAnimation/FreeSpinsAnimation";
import { useSelector } from "react-redux";

const FreeSpinGame = ({ dimensions, symbolSize, freeSpinReelRefs }) => {
  const { showFreeSpinGame } = useSelector((state) => state.freeSpins);

  return (
    <>
      <FreeSpinsAnimation dimensions={dimensions} symbolSize={symbolSize} />
      <Logo dimensions={dimensions} symbolSize={symbolSize} zIndex={5} />

      {showFreeSpinGame && (
        <>
          <BackgroundTexture dimensions={dimensions} type={"feature"} />
          <FreeSpinReelSet
            dimensions={dimensions}
            symbolSize={symbolSize}
            freeSpinReelRefs={freeSpinReelRefs}
          />
        </>
      )}
    </>
  );
};

export default FreeSpinGame;
